<script setup lang="ts">
import type { Editor } from '@tiptap/vue-3'
import { Separator } from '@/foundation/separator'
import ActionButton from '@/notebook/components/ActionButton.vue'
import { useLocale } from '@/notebook/locales'
import { truncate } from '@/notebook/utils/utils'

type Props = {
  editor: Editor
  link?: string
}
withDefaults(defineProps<Props>(), {
  link: undefined,
})
const { t } = useLocale()
const emits = defineEmits(['clear', 'edit'])

function onClear() {
  emits('clear')
}
function onEdit() {
  emits('edit')
}
</script>

<template>
  <div
    class="flex items-center gap-2 p-2 bg-white rounded-lg dark:bg-black shadow-sm border border-neutral-200 dark:border-neutral-800"
  >
    <a :href="link" target="_blank" rel="noopener noreferrer" class="text-sm underline break-all">
      {{
        truncate(link, {
          length: 50,
          omission: '…',
        })
      }}
    </a>
    <Separator v-if="link" orientation="vertical" class="h-4" />
    <div class="flex flex-nowrap">
      <ActionButton
        icon="Pencil"
        :tooltip="t('editor.link.edit.tooltip')"
        :action="onEdit"
        :tooltip-options="{ sideOffset: 15 }"
      />
      <ActionButton
        icon="Unlink"
        :tooltip="t('editor.link.unlink.tooltip')"
        :action="onClear"
        :tooltip-options="{ sideOffset: 15 }"
      />
    </div>
  </div>
</template>
